import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

import getVideoGenres from '../services/getVideoGenres'

export default function useVideoGenres() {
  const { isLoading, data: genres } = useQuery('video_genres', getVideoGenres)

  const { genreSlug } = useParams()

  const activeGenre = genres?.find(g => g.slug === genreSlug) || genres?.[0]

  const activeGenreIndex = genres?.findIndex(g => g === activeGenre)

  const previousGenre =
    genres?.[activeGenreIndex - 1] || genres?.[genres?.length - 1]
  const nextGenre = genres?.[activeGenreIndex + 1] || genres?.[0]

  return {
    isLoading,
    genres,
    activeGenre,
    previousGenre,
    nextGenre,
  }
}
